import { createSelector } from "reselect";
import get from "lodash/get";

const newNumberDomain = state => get(state, "form.NewNumberForm.values");

// ***************************************************************
// ************** newNumberForm selectors ******************
// ***************************************************************

export const newNumberSelector = createSelector(
  newNumberDomain,
  newNumber => newNumber
);

// ***************************************************************
// *************** newNumberForm makeSelect *******************
// ***************************************************************

export const makeSelectNewNumberForm = () => newNumberSelector;
